import { c as _c } from "react/compiler-runtime";
import { Box, Skeleton } from "@mui/material";
import React from "react";
import { PLAYGROUND_DESKTOP_APP_BAR_HEIGHT } from "#/features/appBar/constants";
function PanelSkeleton(t0) {
  const $ = _c(2);
  const {
    flex
  } = t0;
  let t1;
  if ($[0] !== flex) {
    t1 = <Skeleton variant="rectangular" animation="wave" sx={{
      flex,
      borderRadius: 2,
      cursor: "wait"
    }} />;
    $[0] = flex;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  return t1;
}
function SkeletonColumn(t0) {
  const $ = _c(10);
  const {
    flex,
    topFlex,
    bottomFlex
  } = t0;
  let t1;
  if ($[0] !== flex) {
    t1 = {
      flex,
      display: "flex",
      flexDirection: "column",
      gap: 1.5
    };
    $[0] = flex;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  let t2;
  if ($[2] !== topFlex) {
    t2 = <PanelSkeleton flex={topFlex} />;
    $[2] = topFlex;
    $[3] = t2;
  } else {
    t2 = $[3];
  }
  let t3;
  if ($[4] !== bottomFlex) {
    t3 = <PanelSkeleton flex={bottomFlex} />;
    $[4] = bottomFlex;
    $[5] = t3;
  } else {
    t3 = $[5];
  }
  let t4;
  if ($[6] !== t1 || $[7] !== t2 || $[8] !== t3) {
    t4 = <Box sx={t1}>{t2}{t3}</Box>;
    $[6] = t1;
    $[7] = t2;
    $[8] = t3;
    $[9] = t4;
  } else {
    t4 = $[9];
  }
  return t4;
}

/**
 * Desktop-only skeleton shown while the split layout hydrates.
 * Mobile uses `MobilePlayground` directly and does not need this skeleton.
 */
export const SplitPanelsLayoutSkeleton: React.FC = () => {
  const $ = _c(1);
  let t0;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = <Box component="main" sx={{
      height: `calc(100vh - ${PLAYGROUND_DESKTOP_APP_BAR_HEIGHT}px)`,
      width: "100vw",
      px: 1,
      pb: 1,
      overflow: "hidden",
      display: "flex",
      flexDirection: "row",
      gap: 1.5
    }}><SkeletonColumn flex="0 0 60%" topFlex="0 0 15%" bottomFlex="1 1 30%" /><SkeletonColumn flex="1 1 40%" topFlex="1 1 80%" bottomFlex="0 0 30%" /></Box>;
    $[0] = t0;
  } else {
    t0 = $[0];
  }
  return t0;
};